import { ErrorHandler, inject, Injectable } from "@angular/core";
import { AppInsightsService } from "@api/services/app-insights/app-insights.service";

@Injectable()
export class AppErrorHandler implements ErrorHandler {
    private readonly ai = inject(AppInsightsService);

    handleError(error: unknown): void {
        if (error instanceof Error || error instanceof TypeError) {
            this.ai.logException(error);
        } else {
            this.ai.logException(new Error(String(error)));
        }
        console.error("Global error caught:", error);
    }
}
